import { localized, t } from '@weavedev/lit-i18next';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { iconStopwatch } from '@/components/icons';
import { baseStyles, skewedLabelStyles } from '@/styles';
import { LayoutType } from '@/types';

@customElement('fg-hsp-label')
@localized()
export class FgHspLabel extends LitElement {
  @property({ type: Number })
  hspMaximumQuantity?: number | null = 0;

  @property({ type: String })
  layout: LayoutType = 'retail';

  @property({ type: Boolean })
  onlySkewedLabel = false;

  @property({ type: Boolean })
  hasLargeOnlySkewedLabel = false;

  renderSkewedLabel() {
    if (this.hasLargeOnlySkewedLabel) {
      return html`
        <span class="skewed-label">
          <span class="content">
            ${iconStopwatch}
            ${t(this.layout === 'retail' ? 'labels.quickLarge' : 'labels.24h')}
          </span>
        </span>
      `;
    }

    return html`
      <span class="skewed-label">
        <span class="content">${iconStopwatch} ${t('labels.quick')}</span>
      </span>
    `;
  }

  render() {
    if (this.onlySkewedLabel) {
      return this.hasLargeOnlySkewedLabel
        ? this.renderSkewedLabel()
        : html`
            <div class="small">${this.renderSkewedLabel()}</div>
          `;
    }

    if (!this.hspMaximumQuantity) {
      return nothing;
    }

    return html`
      <span class="skewed-label-wrapper">
        ${this.renderSkewedLabel()}
        <span class="max-quick-delivery">
          ${t('labels.maxQuickDelivery', {
            count: this.hspMaximumQuantity,
          })}
        </span>
      </span>
    `;
  }

  static styles = [
    baseStyles,
    skewedLabelStyles,
    css`
      .skewed-label-wrapper {
        align-items: center;
        display: flex;
        gap: 0.5rem;

        .skewed-label {
          margin-right: 0.25rem;
        }

        .max-quick-delivery::first-letter {
          text-transform: uppercase;
        }
      }
    `,
  ];
}
